import { Button, Modal, ModalDialog, FormControl, FormLabel, Input, Stack, IconButton, Select, Option } from "@mui/joy";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { postFetch, getFetch } from "../../../../../../fetch/fetch";
import { dateToDateString } from "../../../etc/etcfunctions";
import { Delete } from "@mui/icons-material";
import totalLocationData from "../../../../../../data/locationdata";
import { englishLocationToKorean, koreanLocationToEnglish } from "../../../../../../data/locationFuntion";

const DAECHI_GROUP_ENG = ["daechi", "daechi2", "daechi3"];

const OtherLocationIncentiveModal: React.FC<any> = (props) => {

    const [rows, setRows] = useState<any[]>([]);
    const [columns] = useState<any[]>([
        {
            field: "locationKorean", headerName: "지점", width: 100
        },
        { field: "date", headerName: "날짜", width: 100 },
        { field: "description", headerName: "내용", width: 220 },
        { field: "amount", headerName: "금액", width: 100 },
        { field: "author", headerName: "작성자", width: 100 },
        { field: "createdAt", headerName: "작성일", width: 150 },
        {
            field: "delete", headerName: "삭제", width: 80, renderCell: (params: any) => {
                const id = params.row.id;

                const deleteIncentive = async () => {
                    try {
                        if (!id) return;

                        if (!window.confirm("정말로 인센티브를 삭제하시겠습니까?")) return;

                        const result: any = await postFetch("/dashboard/salary/deleteotherlocationincentive", {
                            incentiveId: id,
                        });

                        if (result.message === "success") {
                            props.notify("success", "인센티브가 성공적으로 삭제되었습니다.");
                            props.setIncentiveUpdate(Math.random());
                        }
                    } catch (e) {
                        console.log(e);
                    }
                };

                return (
                    <div>
                        <IconButton onClick={deleteIncentive}>
                            <Delete />
                        </IconButton>
                    </div>
                );
            }
        }
    ]);

    const [modalOpen, setModalOpen] = useState(false);

    const [newIncentive, setNewIncentive] = useState({
        location: "",
        date: "",
        description: "",
        amount: "",
    });

    const [loading, setLoading] = useState(false);

    // 타 지점 목록 (본인 지점 그룹 제외)
    const getOtherLocationList = () => {
        if (!props.user) return [];
        const homeEng = koreanLocationToEnglish(props.user.location);
        return totalLocationData.filter((loc) => {
            if (!loc.academy.includes("sunbae") && !loc.academy.includes("bundangsunbae")) return false;
            if (loc.english === "total") return false;
            if (!homeEng) return true;
            if (DAECHI_GROUP_ENG.includes(loc.english) && DAECHI_GROUP_ENG.includes(homeEng)) return false;
            return loc.english !== homeEng;
        });
    };

    const otherLocationList = getOtherLocationList();

    useEffect(() => {
        setNewIncentive({ location: "", date: "", description: "", amount: "" });
    }, [props.open, modalOpen]);

    useEffect(() => {
        if (!props.incentiveData) {
            setRows([]);
            return;
        }

        const newRows: any[] = [];

        props.incentiveData.forEach((item: any) => {
            const oneRow: any = {};
            oneRow.id = item.id;
            oneRow.locationKorean = englishLocationToKorean(item.location) || item.location;
            oneRow.date = dateToDateString(new Date(item.targetDate));
            oneRow.description = item.description;
            oneRow.amount = parseInt(item.amount).toLocaleString() + "원";
            oneRow.author = item.authorName;
            oneRow.createdAt = dateToDateString(new Date(item.createdAt));
            newRows.push(oneRow);
        });

        setRows([...newRows]);
    }, [props.incentiveData]);

    const handleChange = (field: "location" | "date" | "description" | "amount", value: string) => {
        setNewIncentive((prev) => ({ ...prev, [field]: value }));
    };

    const submitNewIncentive = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            if (!props.user) return;
            if (!newIncentive.location || !newIncentive.date || !newIncentive.description || !newIncentive.amount) return;

            setLoading(true);

            const targetDate = new Date(newIncentive.date).getTime();

            await postFetch("/dashboard/salary/addotherlocationincentive", {
                userId: props.user.id,
                date: targetDate,
                location: newIncentive.location,
                description: newIncentive.description,
                amount: Number(newIncentive.amount),
            });

            setNewIncentive({ location: "", date: "", description: "", amount: "" });
            setModalOpen(false);
            setLoading(false);
            props.notify("success", "인센티브가 추가되었습니다.");
            props.setIncentiveUpdate(Math.random());
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    return (
        <div>
            <Modal open={props.open} onClose={props.onClose}>
                <ModalDialog>
                    <div
                        style={{
                            fontSize: "18px",
                            fontWeight: 600,
                            marginBottom: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>
                            {props.selectedDate ? props.selectedDate.getMonth() + 1 + "월" : ""} 타 지점 인센티브 관리
                        </div>
                        <div>
                            <Button variant="outlined" onClick={() => setModalOpen(true)}>
                                인센티브 추가
                            </Button>
                        </div>
                    </div>
                    <div style={{ width: "900px", height: "400px" }}>
                        <DataGridPremium
                            rows={rows}
                            columns={columns}
                            density="compact"
                        />
                    </div>
                </ModalDialog>
            </Modal>

            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                <ModalDialog>
                    <form onSubmit={submitNewIncentive}>
                        <Stack spacing={2}>
                            <div style={{ fontSize: "18px", fontWeight: 600 }}>
                                타 지점 인센티브 추가하기
                            </div>

                            <FormControl>
                                <FormLabel>지점</FormLabel>
                                <Select
                                    value={newIncentive.location}
                                    onChange={(_e: any, val: any) => handleChange("location", val ?? "")}
                                    placeholder="지점을 선택하세요"
                                    required
                                >
                                    {otherLocationList.map((loc) => (
                                        <Option key={loc.english} value={loc.english}>
                                            {loc.korean}
                                        </Option>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl>
                                <FormLabel>날짜</FormLabel>
                                <Input
                                    type="date"
                                    value={newIncentive.date}
                                    onChange={(e) => handleChange("date", e.target.value)}
                                    required
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>내용</FormLabel>
                                <Input
                                    placeholder="내용을 입력하세요"
                                    value={newIncentive.description}
                                    onChange={(e) => handleChange("description", e.target.value)}
                                    required
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>금액</FormLabel>
                                <Input
                                    type="number"
                                    placeholder="금액을 입력하세요"
                                    value={newIncentive.amount}
                                    onChange={(e) => handleChange("amount", e.target.value)}
                                    required
                                />
                            </FormControl>

                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                                <Button variant="outlined" type="button" onClick={() => setModalOpen(false)}>
                                    취소
                                </Button>
                                <Button
                                    type="submit"
                                    loading={loading}
                                    disabled={
                                        loading
                                        || !newIncentive.location
                                        || !newIncentive.date
                                        || !newIncentive.description
                                        || !newIncentive.amount
                                    }
                                >
                                    전송
                                </Button>
                            </Stack>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>
        </div>
    );
};

export default OtherLocationIncentiveModal;
